import React from "react";
import { Box, Typography } from "@mui/material";
import axios from "../../utils/axios.tsx";
import TallyDialog from "../dialog/TallyDialog.tsx";
import TileCard from "../common/TileCard.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

interface MemoryCardProps {
  id: string;
  memory: string;
  onMemoryUpdated: () => void;
}

const MemoryCard: React.FC<MemoryCardProps> = ({
  id,
  memory,
  onMemoryUpdated,
}) => {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [displayText, setDisplayText] = React.useState(memory);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleEditSubmit = async (newMemoryText: string) => {
    await axios.patch(
      `/v1/memory/${id}/`,
      JSON.stringify({ memory: newMemoryText }),
    );
    setDisplayText(newMemoryText);
    onMemoryUpdated();
    handleCloseDialog();
  };

  return (
    <>
      <TileCard onClick={handleOpenDialog}>
        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {displayText}
            </Typography>
          </Box>
        </Box>
      </TileCard>

      <TallyDialog
        open={isDialogOpen}
        title={i18n._(
          msg({
            context: "Title of a dialog enabling the user to edit a memory.",
            message: "Edit memory",
          }),
        )}
        subtitle={i18n._(
          msg({
            context:
              "Subtitle of a dialog explaining how the application uses the memory to improve responses in the future.",
            message:
              "By creating a memory, I will learn the information so I can use it going forward in our conversations",
          }),
        )}
        submitTitle={i18n._(
          msg({
            context: "Button title of the edit memory dialog.",
            message: "Save",
          }),
        )}
        onSubmit={handleEditSubmit}
        initialInputValue={displayText}
        handleDialogClose={handleCloseDialog}
      />
    </>
  );
};

export default MemoryCard;
